class SeatAlreadyOccupiedError extends Error {
  constructor(message) {
    super(message);
    this.name = "SeatAlreadyOccupiedError";
  }
}

export default SeatAlreadyOccupiedError;
